import { Column } from "@/models/table";

export const autosizeOptions = {
    includeOutliers: false,
    includeHeaders: true,
    expand: true,
};

export const getFilterableCols = (columns: Column[], columnVisibilityModel = []) => {
    const columnVisibilityModelSet = new Set(Object.keys(columnVisibilityModel));
    const filterableColumns = [];
    const columnsLength = columns.length;

    for (let i = 0; i < columnsLength; i++) {
        if (columns[i].filterable && !columnVisibilityModelSet.has(columns[i]?.field)) {
            filterableColumns.push(columns[i]);
        }
    }

    return filterableColumns;
};

export const formatCell = (value, { format, hasSubtext }: Column) => {
    const PLAIN_VALUES = ["stock_list", "consensus", "arrow_str"];

    if (PLAIN_VALUES.includes(format) || hasSubtext) return value;
    return [value];
};

export const getExtraHiddenCols = (hiddenColumns: string[]) => {
    if (!hiddenColumns) return null;
    return hiddenColumns.reduce((acc, item) => {
        acc[item] = false;
        return acc;
    }, {});
};

// export const perPageRowsQty = "25";
export const BASE_WIDTH = 50;
